module.exports = __webpack_public_path__ + "images/category_lp/common/woman_40_65ff14fc737a3eb2a98d92e5919d3c15.png";